import { createAction, props } from '@ngrx/store';

import { LiveFilterNamespace, LiveFilterTypesKeys } from '@live/components/live-filters/interfaces';

import INextPage = Microsoft.VideoIndexer.Contracts.INextPage;

export const loadFilter = createAction('[Live Filters/API] list filter', props<{ filterType: LiveFilterTypesKeys }>());
export const loadFilterStarted = createAction('[Live Filters] list filter started', props<{ filterType: LiveFilterTypesKeys }>());
export const loadFilterSucceeded = createAction(
  '[Live Filters] list filter success',
  props<{ filterType: LiveFilterTypesKeys; filter: unknown[]; nextPage: INextPage }>()
);
export const loadFilterFailed = createAction('[Live Filters] list filter failure', props<{ filterType: LiveFilterTypesKeys; error: string }>());

export const applyFilter = createAction(
  '[Live Filters/API] apply filter',
  props<{ filterType: LiveFilterTypesKeys; filterValues: Record<string, string>[]; options?: { shouldAvoidRefetchFromAPI?: boolean } }>()
);
export const clearFilter = createAction('[Live Filters/API] clear filter', props<{ filterType: LiveFilterTypesKeys }>());
export const removeFilter = createAction('[Live Filters/API] remove filter', props<{ filterType: LiveFilterTypesKeys }>());
export const removeFilters = createAction('[Live Filters/API] remove filters', props<{ filterNamespace: keyof LiveFilterNamespace }>());
